import React, { createContext } from "react";
export var linkContextDefaultValue = {
    LinkComponent: function(param) {
        var draggable = param.draggable, href = param.href, title = param.title, download = param.download, target = param.target, label = param.label, className = param.className, onClick = param.onClick, children = param.children;
        return /*#__PURE__*/ React.createElement("a", {
            draggable: draggable,
            title: title,
            download: download,
            target: target,
            href: href,
            className: className,
            onClick: onClick
        }, children || label);
    }
};
export var LinkContext = /*#__PURE__*/ createContext(linkContextDefaultValue);

//# sourceMappingURL=LinkContext.js.map